import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ChunkPlayer } from '../../../../../../fragments/screens/view/components/media-detail/audio/chunk-player/ChunkPlayer';
import { useFragmentEditorStore } from '../../stores/useFragmentEditorStore';

/**
 * Renders the list of chunks in the editor using the shared ChunkPlayer.
 * Each chunk is editable with delete, move, and label edit actions.
 * Playback mode is automatically detected: uses parent PlaybackProvider from logger.
 */
export function EditorChunksList() {
  const station = useActiveStation();
  const fragment = useFragmentEditorStore((state) => state.fragment);
  const deleteChunk = useFragmentEditorStore((state) => state.deleteChunk);
  const moveChunk = useFragmentEditorStore((state) => state.moveChunk);
  const setChunkLabel = useFragmentEditorStore((state) => state.setChunkLabel);

  if (!fragment) {
    return null;
  }

  const chunks = fragment.chunks;

  return (
    <div>
      {chunks.map((chunk, index) => (
        <ChunkPlayer
          key={chunk.from}
          chunk={chunk}
          index={index}
          totalChunks={chunks.length}
          station={station}
          editable={true}
          showHeader={true}
          onDelete={() => deleteChunk(chunk)}
          onMoveBefore={() => moveChunk(chunk, 'left')}
          onMoveAfter={() => moveChunk(chunk, 'right')}
          onSetLabel={(label) => setChunkLabel(chunk, label)}
        />
      ))}
    </div>
  );
}
